export const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
};

export const getAddressComponent = (addressComponents, type) => {
    const component = addressComponents.find((c) => c.types.includes(type));
    return component ? component.long_name : "";
};
